//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'month_form',
        data(){
            return{
                a:1,
                id:this.$route.query.id
            }
        },
        methods:{
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            },
            edit(){

            }
        },
        created(){
            if(this.$route.query.a){
                this.a = this.$route.query.a
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form.vue